
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/news",
      function () {
        return require("private-next-pages/ir/news.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/news"])
      });
    }
  